module.exports = __webpack_public_path__ + "static/img/7.32fe201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/7.png
// module id = qNqt
// module chunks = 0